import { c as _c } from "react/compiler-runtime";
import { NearbyProject } from "@/hooks/use-nearby-projects";
import { useMemo } from "react";
type Cluster = {
  points: NearbyProject[];
  center: {
    lat: number;
    lng: number;
  };
  count: number;
};
interface ClusterMarkerProps {
  cluster: Cluster;
  /** Optional custom color override */
  color?: string;
  /** Optional custom size override */
  size?: number;
  /** Click handler for the marker */
  onClick?: () => void;
  /** Additional CSS classes */
  className?: string;
}

/**
 * ClusterMarker - Renders a map marker for single points or clustered points
 *
 * @example
 * // Single marker
 * <ClusterMarker count={1} onClick={() => console.log('clicked')} />
 *
 * @example
 * // Cluster marker
 * <ClusterMarker count={25} onClick={() => handleClusterClick()} />
 */
export function ClusterMarker(t0) {
  const $ = _c(18);
  const {
    cluster,
    color: customColor,
    size: customSize,
    onClick,
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const count = cluster.count;
  const getClusterStyle = _temp;
  let t2;
  if ($[0] !== count) {
    t2 = getClusterStyle(count);
    $[0] = count;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    color: defaultColor,
    size: defaultSize
  } = t2;
  const color = customColor || defaultColor;
  const size = customSize || defaultSize;
  const isCluster = cluster.count > 1;
  let t3;
  if ($[2] !== onClick) {
    t3 = e => {
      if (onClick && (e.key === "Enter" || e.key === " ")) {
        e.preventDefault();
        onClick();
      }
    };
    $[2] = onClick;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = `
        relative flex items-center justify-center rounded-full 
        border-2 border-white shadow-lg cursor-pointer 
        transform transition-all duration-200 hover:scale-110
        ${className}
      `;
  const t5 = size * 2;
  const t6 = size * 2;
  let t7;
  if ($[4] !== color || $[5] !== t5 || $[6] !== t6) {
    t7 = {
      backgroundColor: color,
      width: t5,
      height: t6,
      boxShadow: "0 4px 6px rgba(0,0,0,0.3)"
    };
    $[4] = color;
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const t8 = isCluster ? `Cluster of ${count} markers` : "Single marker";
  let t9;
  if ($[8] !== count || $[9] !== isCluster) {
    t9 = isCluster ? <span className="text-white font-bold text-xs select-none">{count}</span> : <div className="w-2 h-2 rounded-full bg-white" aria-hidden="true" />;
    $[8] = count;
    $[9] = isCluster;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== onClick || $[12] !== t3 || $[13] !== t4 || $[14] !== t7 || $[15] !== t8 || $[16] !== t9) {
    t10 = <div role="button" tabIndex={0} onClick={onClick} onKeyDown={t3} className={t4} style={t7} aria-label={t8}>{t9}</div>;
    $[11] = onClick;
    $[12] = t3;
    $[13] = t4;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  return t10;
}
function _temp(count_0) {
  if (count_0 === 1) {
    return {
      color: "oklch(60.15% 0.1603 23.21)",
      size: 8
    };
  }
  if (count_0 < 5) {
    return {
      color: "oklch(72.18% 0.0998 214.86)",
      size: 12
    };
  }
  if (count_0 < 10) {
    return {
      color: "oklch(74.58% 0.1128 64.57)",
      size: 16
    };
  }
  return {
    color: "oklch(60.9% 0.1565 22.91)",
    size: 20
  };
}